<template>
	<div class="scoreBox">
		<div class="scoreBoxTitle">
			<div class="scoreBoxTitle-left">
				<img src="../../assets/tennis/icon2.png" alt="">
				<span>2023五星网球分级挑战赛年终总决赛</span>
			</div>
			<div class="scoreBoxTitle-right">
				<div class="btnBox33">
					<div class="mainBoxCon-m1">
						<van-dropdown-menu active-color="#619568" :overlay="false">
						  <van-dropdown-item @change="onchange" v-model="trackid" :options="trackids" />
						</van-dropdown-menu>
					</div>
				</div>
				<div class="btnBox">
					<img src="../../assets/tennis/icon3.png" alt="">
					<span>设置模式</span>
				</div>
				<div class="btnBox">
					<img src="../../assets/tennis/icon4.png" alt="">
					<span>退出登录</span>
				</div>
			</div>
		</div>
		<div class="setting">
			<div class="setting-left">
				<div class="setting-left-img">
					<img src="../../assets/tennis/icon8.png" alt="">
				</div>
				<div class="setting-left-class">
					<div :class="[idx == index ? 'active0001' : 'set-m1']" :data-index="index" v-for="(item, index) in modules" @click="changeModule(index)">
						{{ item }}
					</div>
				</div>
			</div>
			<!-- 轮次设置 -->
			<div class="setting-right" v-if="idx == 0">
				<div class="xuanshou1">
					<img src="../../assets/tennis/icon5.png" alt="">
					<span>选择轮次</span>
				</div>
				<div class="mainBox">
					<div class="mainBoxCon">
						<div class="mainBoxCon-title">当前打分轮次:</div>
						<div class="mainBoxCon-m1">
							<van-dropdown-menu active-color="#619568" :overlay="false">
							  <van-dropdown-item @change="onchangeLunCi" v-model="value1" :options="option1" />
							</van-dropdown-menu>
						</div>
					</div>
				</div>
				<div class="btnBox">
					<van-button type="primary" @click="toPage">确定</van-button>
				</div>
				<div class="textBox">
					<div class="textBox-m1" v-if="text1 != ''">
						<div>{{ '大屏链接：'+text1 }}</div>
						<van-button type="primary" @click="copyUrl(text1)">复制链接</van-button>
					</div>
					<div class="textBox-m1" v-if="text2 != ''">
						<div>{{ '字幕链接：'+text2 }}</div>
						<van-button type="primary" @click="copyUrl(text2)">复制链接</van-button>
					</div>
				</div>
			</div>
			
			<!-- 淘汰对阵 -->
			<div class="setting-right" v-if="idx == 1">
				<div class="xuanshou1">
					<img src="../../assets/tennis/icon5.png" alt="">
					<span>淘汰对阵</span>
				</div>
				<div class="mainBox2">
					<div class="mainBox2-m1">
						<div class="mainBox2-m1-title">
							<span class="text01">可选队伍</span>
							<span class="text02">{{ sLeftPerson.length }}/{{ leftPersons.length }}</span>
						</div>
						<div class="list">
							<div class="item" v-for="(item, index) in leftPersons">
								<van-checkbox shape="square" icon-size="0.16rem" @click="onchangePerson(index, item)" checked-color="#619568" v-model="item.checked">
									<span>{{ item.name }}</span>
								</van-checkbox>
								
							</div>
						</div>
					</div>
					<div class="operationBtn">
						<img :class="[sRightPerson.length == 0 ? 'left' : 'left2']" src="../../assets/tennis/left.png" alt="" @click="transfer(0)">
						<img :class="[sLeftPerson.length == 0 ? 'left' : 'left2']" src="../../assets/tennis/right.png" alt="" @click="transfer(1)">
					</div>
					<div class="mainBox2-m1">
						<div class="mainBox2-m1-title">
							<span class="text01">已选择晋级队伍</span>
							<span class="text02">{{ sRightPerson.length }}/{{ rightPersons.length }}</span>
						</div>
						<div class="list">
							<div class="item" v-for="(item, index) in rightPersons">
								<van-checkbox shape="square" icon-size="0.16rem" checked-color="#619568" @click="onchangePerson2(index, item)" v-model="item.checked">
									<img src="../../assets/tennis/team.png" alt="">
									<span>{{ item.name }}</span>
								</van-checkbox>
								<!-- <img src="../../assets/tennis/team.png" alt="">
								<span>{{ item.name }}</span> -->
							</div>
						</div>
					</div>
				</div>
				<div class="btnBox">
					<van-button type="primary" @click="comfirmPerson">确定</van-button>
				</div>
				
			</div>
		</div>
		
	</div>
</template>

<script>

export default {
	name: 'score',
	data(){
		return {
			checked: false,
			
			modules: ['轮次设置', '淘汰对阵'],
			idx: 1,
			
			leftPersons: [],
			rightPersons: [],
			selectPersonNum: 0,
			leftNum: 0,
			rightNum: 0,
			sLeftPerson: [],
			sRightPerson: [],
			
			value1: 0,
			option1: [
				{ text: '第21轮 —— 第24组：刘云坤、周嘉成', value: 0 },
				{ text: '第1轮 —— 第4组：刘云坤、周嘉成', value: 1 },
				{ text: '第1轮 —— 第4组：刘云坤、周嘉成', value: 2 },
			],
			
			trackids: [],
			trackid: 0,
			
			text1: '',
			text2: '',
			
			
			
			
		}
	},
	mounted() {
		this.matchid = this.$route.query.matchid
		// this.trackid = this.$route.query.trackid ? this.trackid : ''
		if(this.$route.query.groupnum == ''){
			this.groupnum = ''
			// this.value1 = ''
		}else{
			this.groupnum = this.$route.query.groupnum
			// this.value1 = this.$route.query.groupnum
			
		}
		if(this.$route.query.isset == 1){
			this.idx = 0
		}
		
		var data = {
			matchid: this.matchid
		}
		this.getTrackid(data);
	},
	methods: {
		changeModule(i){
			this.idx = i
			if(i == 1){
				this.getAllPerson()
			}
		},
		onchange(){
			console.log("uiuiui", this.trackid)
			this.getData()
			this.getAllPerson()
		},
		onchangePerson(index, item){
			console.log("e",index, item)
			if(item.checked == true){
				this.sLeftPerson.push({
					checked: false,
					name: item.name,
					number: item.number
				})
			}else{
				this.sLeftPerson.forEach((sitem, sindex) => {
					this.sLeftPerson.splice(sindex, 1)
				})
				
			}
		},
		onchangePerson2(index, item){
			console.log("e",index, item)
			if(item.checked == true){
				this.sRightPerson.push({
					checked: false,
					name: item.name,
					number: item.number
				})
			}else{
				this.sRightPerson.forEach((sitem, sindex) => {
					this.sRightPerson.splice(sindex, 1)
				})
			}
		},
		toPage(){
			this.option1.forEach((item, index) => {
				if(this.value1 == item.value){
					if(item.state == 2){
						this.$router.push({
							name: 'tennisreferee',
							query: {
								matchid: this.matchid,
								trackid: this.trackid,
								groupnum: this.value1
							}
						})
						
					}else{
						this.$toast({
							className: 'mytoast',
							type: 'fail',
							message: '暂时不能打分!',
							// duration: 0
						});
					}
				}
				
			})
			
		},
		onchangeLunCi(e){
			this.text1 = `https://bk.h5.movecloud.cn/activity/tennisdashboard?matchid=${this.$route.query.matchid}&trackid=${this.$route.query.trackid}&groupnum=${e}`
			this.text2 = `https://bk.h5.movecloud.cn/activity/tennissubtitle?matchid=${this.$route.query.matchid}&trackid=${this.$route.query.trackid}&groupnum=${e}`
			console.log('----', e)
		},
		copyUrl(val) {
			// 模拟 输入框
			var cInput = document.createElement("input");
			cInput.value = val;
			document.body.appendChild(cInput);
			cInput.select(); // 选取文本框内容

			// 执行浏览器复制命令
			// 复制命令会将当前选中的内容复制到剪切板中（这里就是创建的input标签）
			// Input要在正常的编辑状态下原生复制方法才会生效

			document.execCommand("copy");

			this.$toast({
				className: 'mytoast',
				type: 'success',
				message: '复制成功!',
				// duration: 0
			});
		// 复制成功后再将构造的标签 移除
			document.body.removeChild(cInput);
		},
		getData(){
			let _this = this
			// this.matchid = this.$route.query.matchid
			// this.trackid = this.$route.query.trackid
			var data = {
				matchid: this.matchid,
				trackid: this.trackid,
			}
			
			this.$api.tennis
				.getPersonsData(data)
				.then((res) => {
					if (res.status * 1 === 200) {
						// option1: [
						// 	{ text: '第21轮 —— 第24组：刘云坤、周嘉成', value: 0 },
						// 	{ text: '第1轮 —— 第4组：刘云坤、周嘉成', value: 1 },
						// 	{ text: '第1轮 —— 第4组：刘云坤、周嘉成', value: 2 },
						// ],
						let arr = []
						res.data.forEach((item, index) => {
							if(item.enrollinfo.length == 2){
								var nitem = {
									value: item.groupnum,
									text: `${item.groupname}:${item.enrollinfo[0].name}、${item.enrollinfo[1].name}`, 
									state: 2,
								}
							}
							if(item.enrollinfo.length == 1){
								var nitem = {
									value: item.groupnum,
									text: `${item.groupname}:${item.enrollinfo[0].name}`,
									state: 1,
								}
							}
							if(item.enrollinfo.length == 0){
								var nitem = {
									value: item.groupnum,
									text: `${item.groupname}: --`,
									state: 0,
								}
							}
							arr.push(nitem)
						})
						this.option1 = arr
						if(this.$route.query.groupnum == '' || this.$route.query.groupnum == undefined){
							this.value1 = this.option1[0].value
							this.text1 = ''
							this.text2 = ''
						}else{
							this.value1 = this.$route.query.groupnum
							this.text1 = `https://bk.h5.movecloud.cn/activity/tennisdashboard?matchid=${this.$route.query.matchid}&trackid=${this.$route.query.trackid}&groupnum=${this.$route.query.groupnum}`
							this.text2 = `https://bk.h5.movecloud.cn/activity/tennissubtitle?matchid=${this.$route.query.matchid}&trackid=${this.$route.query.trackid}&groupnum=${this.$route.query.groupnum}`
						}
					}
			});
		},
		getAllPerson(){
			var data = {
				matchid: this.matchid,
				trackid: this.trackid,
			}
			this.$api.tennis
				.getAllPersonData(data)
				.then((res) => {
					if (res.status * 1 === 200) {
						let arr = []
						let arr2 = []
						res.data.enrolllist.forEach((item, index) => {
							arr.push({
								name: item.name,
								number: item.number,
								checked: false
							})
						})
						this.leftPersons = arr
						res.data.grouplist.forEach((item, index) => {
							if(item.enrollinfo.length != 0){
								item.enrollinfo.forEach((_item, _index) => {
									arr2.push({
										name: _item.name,
										number: _item.number,
										checked: false
									})
								})
							}
						})
						this.rightPersons = arr2
					}
			});
		},
		getTrackid(data){
			this.$api.tennis
				.getTrackid(data)
				.then((res) => {
					if (res.status * 1 === 200) {
						// option1: [
						// 	{ text: '第21轮 —— 第24组：刘云坤、周嘉成', value: 0 },
						// 	{ text: '第1轮 —— 第4组：刘云坤、周嘉成', value: 1 },
						// 	{ text: '第1轮 —— 第4组：刘云坤、周嘉成', value: 2 },
						// ],
						var arr = []
						res.data.forEach((item, index) => {
							arr.push({
								text: item.name,
								value: item.trackid,
								groupnum: item.groupnum,
							})
						})
						this.trackids = arr
						this.trackid = this.$route.query.trackid ? this.$route.query.trackid : this.trackids[0].value
						// this.trackid = 
						this.getData()
						this.getAllPerson()
					}
			});
		},
		transfer(state){
			if(state == 0){
				// 左移
				if(this.sRightPerson.length == 0){
					this.$toast({
						className: 'mytoast',
						type: 'fail',
						message: '请先勾选队伍!',
						// duration: 0
					});
					return
				}else{
					this.sRightPerson.forEach((item, index) => {
						// this.leftPersons.push(item)
						this.rightPersons.forEach((item2, index2) => {
							if(item.number == item2.number){
								this.rightPersons.splice(index2, 1)
							}
						})
						var n = 0
						this.leftPersons.forEach((item3, index3) => {
							if(item.number == item3.number){
								n = n + 1
							}
						})
						if(n == 0){
							this.leftPersons.push(item)
						}
					})
					this.sRightPerson = []
					
				
				}
				
			}else{
				// 右移
				console.log('sLeftPerson', this.sLeftPerson)
				if(this.sLeftPerson.length == 0){
					this.$toast({
						className: 'mytoast',
						type: 'fail',
						message: '请先勾选队伍!',
						// duration: 0
					});
					return
				}else{
					// this.leftNum = 0
					// console.log('uuu', this.sLeftPerson)
					// return;
					this.sLeftPerson.forEach((item, index) => {
						this.rightPersons.push(item)
						this.leftPersons.forEach((item2, index2) => {
							if(item.number == item2.number){
								this.leftPersons.splice(index2, 1)
							}
						})
						
					})
					this.sLeftPerson = []
					
				}
			}
		},
		comfirmPerson(){
			if(this.rightPersons.length == 0){
				this.$toast({
					className: 'mytoast',
					type: 'fail',
					message: '请选择晋级队伍!',
					// duration: 0
				});
				return
			}
			var arr = []
			this.rightPersons.forEach((item, index) => {
				arr.push({
					name: item.name,
					number: item.number
				})
			})
			var data = {
				matchid: this.matchid,
				trackid: this.trackid,
				enrolls: JSON.stringify(arr)
			}
			// this.$api.tennis
			// 	.submitPerson(data)
			// 	.then((res) => {
			// 		if (res.status * 1 === 200) {
			// 			this.$toast({
			// 				className: 'mytoast',
			// 				type: 'success',
			// 				message: '成功提交!',
			// 				// duration: 0
			// 			});
			// 			this.getData()
			// 		}
			// });
			this.$api.tennis
				.submitPersonData(data)
				.then((res) => {
					if (res.status * 1 === 200) {
						this.$toast({
							className: 'mytoast',
							type: 'success',
							message: '成功提交!',
							// duration: 0
						});
						this.getData()
					}
			});
			
		},
	}
}
</script>

<style lang="less" scoped>
@import './setting.less';
</style>
